var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyThin = function SvgCopyThin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94591 11.2504C2.19157 11.2504 2.11614 11.2504 2.11614 11.2504C1.58811 11.2504 1.21094 10.8072 1.21094 10.3639V1.94216C1.21094 1.42504 1.66354 1.05566 2.11614 1.05566H10.1875C10.7156 1.05566 11.0927 1.49891 11.0927 1.94216C11.0927 1.94216 11.0927 2.23766 11.0927 2.97641",
    stroke: "#333333",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 14.9443H5.81267C5.28463 14.9443 4.83203 14.501 4.83203 13.9839V5.70989C4.83203 5.19276 5.28463 4.74951 5.81267 4.74951H13.8086C14.3367 4.74951 14.7893 5.19276 14.7893 5.70989V13.9839C14.7893 14.501 14.3367 14.9443 13.8086 14.9443Z",
    stroke: "#333333",
    strokeMiterlimit: 10,
    fill: "transparent"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyThin);
export default ForwardRef;